import React from "react";

const CalculatorSection = () => {
  return (
    <section className="prt-row padding_top_zero-section prt-bg bg-base-dark z-index-0 clearfix">
      <div className="prt-row-wrapper-bg-layer prt-bg-layer bg-base-dark"></div>
      <div className="container-fluid">
        <div className="row">
          {/* Columna izquierda: Opciones y beneficios de la cita */}
          <div className="col-xl-6 col-lg-12">
            <div className="prt-bg prt-col-bgimage-yes bg-base-gradient spacing-5 ml_15 res-1199-ml-0">
              <div className="prt-col-wrapper-bg-layer prt-bg-layer"></div>
              <div className="layer-content">
                <div>
                  <h3 className="grid-box-heading">Reserva tu Cita</h3>
                  <ul className="prt-list style2">
                    <li className="prt-list-item style2">
                      <div className="prt-list-text style2">Consultas Presenciales en Clínica</div>
                    </li>
                    <li className="prt-list-item style2">
                      <div className="prt-list-text style2">
                        Consultas Virtuales vía Skype, WhatsApp o Email
                      </div>
                    </li>
                    <li className="prt-list-item style2">
                      <div className="prt-list-text style2">Atención Personalizada y Profesional</div>
                    </li>
                    <li className="prt-list-item style2">
                      <div className="prt-list-text style2">Horarios Flexibles</div>
                    </li>
                  </ul>
                  <div>
                    <h3 className="box-bottom-heading">
                      ¡Tu camino hacia una mejor salud comienza con el primer paso!
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Columna derecha: Formulario para reservar la cita */}
          <div className="col-xl-6 col-lg-12">
            <div className="prt-bg bg-base-lightgrey spacing-6 mr_15 res-1199-mt-30 res-1199-mr-0">
              <div className="prt-col-wrapper-bg-layer prt-bg-layer">
                <div className="prt-col-wrapper-bg-layer-inner"></div>
              </div>
              <div className="layer-content">
                <h3 className="grid-box-heading">Haz tu Reserva</h3>
                <div className="prt-form">
                  <form
                    id="appointment-form"
                    name="appointment-form"
                    data-name="Formulario de Cita"
                    method="post"
                    className="submit-form"
                    aria-label="Formulario de Cita"
                  >
                    <div className="row">
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="input"
                          maxLength="256"
                          name="nombre"
                          data-name="Nombre"
                          placeholder="Nombre Completo"
                          id="name-input"
                          required
                        />
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="email"
                          className="input"
                          maxLength="256"
                          name="correo"
                          data-name="Correo"
                          placeholder="Correo Electrónico"
                          id="email-input"
                          required
                        />
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="tel"
                          className="input"
                          maxLength="256"
                          name="telefono"
                          data-name="Teléfono"
                          placeholder="Número de Teléfono"
                          id="phone-input"
                          required
                        />
                      </div>
                      <div className="col-lg-6">
                        <select
                          id="tipo-cita"
                          name="tipo-cita"
                          data-name="Tipo de Cita"
                          className="select"
                        >
                          <option value="">Selecciona el Tipo de Cita</option>
                          <option value="presencial">Consulta Presencial</option>
                          <option value="virtual">Consulta Virtual</option>
                        </select>
                      </div>
                      <div className="col-lg-12">
                        <input
                          type="date"
                          className="input"
                          name="fecha"
                          data-name="Fecha"
                          placeholder="Fecha Preferida"
                          id="date-input"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 mt-20">
                      <button
                        className="prt-btn prt-btn-size-md prt-btn-shape-square prt-btn-style-fill prt-btn-color-skin w-100"
                        type="submit"
                      >
                        ¡Reserva tu Cita Ahora!
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
    </section>
  );
};

export default CalculatorSection;
